module.exports = __webpack_public_path__ + "2f331da4d776a68af8c92b9552c08929.png";